import { DistributionChannel as CampaignDistributionChannel } from '@phrasee/phrasee-typings/Graphql/interfaces'

import { DistributionChannel as ProjectDistributionChannel } from 'common/interfaces/projects'

export const formatDistributionChannel = (
  val: ProjectDistributionChannel | CampaignDistributionChannel
): string => {
  if (val === 'push_notification') {
    return 'Push'
  } else if (val === 'web_push') {
    return 'Web push'
  } else if (val === 'sms') {
    return 'SMS'
  } else if (val === 'email') {
    return 'Email subject lines'
  } else if (val === 'email_in_body') {
    return 'Email in body'
  } else {
    return val?.replace(/_/g, ' ') ?? ''
  }
}
